import * as React from "react";
import { UserOutlined } from "@ant-design/icons";
import classnames from "classnames";

import Tooltip from "components/ui/tooltip/Tooltip";

import css from "./UserInitials.module.scss";

export type UserInitialsType = "default" | "small" | "extra-small";

export type UserInitialsColour =
  | "pink"
  | "turquoise"
  | "yellow"
  | "blue"
  | "gold"
  | "dark-blue"
  | "green"
  | "orange"
  | "light-green"
  | "red"
  | "grey";

type Props = {
  firstName?: string;
  lastName?: string;
  showTooltip?: boolean;
  className?: string;
  type?: UserInitialsType;
  color?: UserInitialsColour;
};
export const colours: UserInitialsColour[] = [
  "pink",
  "turquoise",
  "yellow",
  "blue",
  "gold",
  "dark-blue",
  "green",
  "orange",
  "light-green",
  "red",
];

function getUserColour(firstName?: string, lastName?: string) {
  const first = firstName?.charCodeAt(0) ?? 0;
  const second = lastName?.charCodeAt(0) ?? 0;
  const userNumber = first + second;
  const colourIndex = userNumber % colours.length;
  return colours[colourIndex];
}

/**
 * @deprecated Use {@link components/ui/form_components/UserInitials.tsx} instead.
 */
function UserInitials({
  className,
  showTooltip = true,
  firstName,
  lastName,
  color,
  type = "default",
}: Props): JSX.Element {
  const initials = (firstName?.charAt(0) || "") + (lastName?.charAt(0) || "");
  const userColour = React.useMemo(
    () => color || getUserColour(firstName, lastName),
    [color, firstName, lastName],
  );
  return (
    <Tooltip content={showTooltip ? `${firstName} ${lastName}` : undefined}>
      <div
        className={classnames(
          css.assigned,
          css.userInitialsContainer,
          className,
          css[userColour],
          css[type],
        )}
      >
        <span>{initials.toUpperCase()}</span>
      </div>
    </Tooltip>
  );
}

export function UnassignedIcon({
  showTooltip = true,
  className,
  type = "default",
}: {
  showTooltip?: boolean;
  className?: string;
  type?: UserInitialsType;
}): JSX.Element {
  return (
    <Tooltip content={showTooltip ? "Unassigned" : undefined}>
      <div className={classnames(css.unassigned, css.userInitialsContainer, className, css[type])}>
        <UserOutlined />
      </div>
    </Tooltip>
  );
}

export default UserInitials;
